import { render, staticRenderFns } from "./QuickPayments.vue?vue&type=template&id=b53ede2e&"
import script from "./QuickPayments.vue?vue&type=script&lang=js&"
export * from "./QuickPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports